import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["rotate", "rotateLock"],
  _excluded2 = ["backgroundColor", "borderColor", "borderRadius", "borderStyle", "borderWidth", "color", "innerClassName", "innerStyles", "name", "rotate", "rotateLock", "size", "style", "verticalAlign"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ICON_SIZES } from './IconConstants';
import UIIcon from './UIIcon';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const Outer = styled.span.withConfig({
  displayName: "UIIconHolder__Outer",
  componentId: "g9s6yq-0"
})(["display:inline-flex;font-size:", ";line-height:1;padding:", ";transform:", ";user-select:none;position:relative;&.private-icon-circle--legacy{display:inline-flex;align-items:center;height:2em;justify-content:center;width:2em;}"], ({
  size
}) => size != null && `${ICON_SIZES[size] || size}px`, ({
  padding
}) => padding != null && `${padding}em`, ({
  rotate
}) => rotate != null && `rotate(${rotate}deg)`);
const getIconTransform = ({
  rotate,
  rotateLock
}) => rotate != null && !rotateLock ? `rotate(${rotate * -1}deg)` : null;
const Icon = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UIIcon, Object.assign({}, rest));
}).withConfig({
  displayName: "UIIconHolder__Icon",
  componentId: "g9s6yq-1"
})(["height:1em;width:1em;margin:0.25em 0.125em 0;transform-origin:50% 38%;transform:", " translateY(-6.3%);"], getIconTransform);

// The MemoExoticComponent type does not allow propTypes or defaultProps

const UIconHolderComponent = props => {
  const {
      backgroundColor,
      borderColor,
      borderRadius,
      borderStyle,
      borderWidth,
      color,
      innerClassName,
      innerStyles,
      name,
      rotate,
      rotateLock,
      size,
      style,
      verticalAlign
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsx(Outer, Object.assign({}, rest, {
    rotate: rotate,
    size: size,
    style: Object.assign({
      backgroundColor,
      borderColor,
      borderRadius,
      borderStyle,
      borderWidth,
      verticalAlign
    }, style),
    children: /*#__PURE__*/_jsx(Icon, {
      className: innerClassName,
      color: color,
      name: name,
      rotate: rotate,
      rotateLock: rotateLock,
      size: size,
      style: innerStyles
    })
  }));
};
const UIIconHolder = /*#__PURE__*/memo(UIconHolderComponent);
UIIconHolder.propTypes = {
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.string,
  borderStyle: PropTypes.oneOf(['solid', 'double', 'dashed', 'dotted', 'initial', 'inherit', 'unset']),
  borderWidth: PropTypes.number,
  verticalAlign: PropTypes.string,
  classname: PropTypes.string,
  color: UIIcon.propTypes.color,
  innerClassName: PropTypes.string,
  name: UIIcon.propTypes.name,
  padding: PropTypes.number,
  rotate: PropTypes.number,
  rotateLock: PropTypes.bool,
  size: UIIcon.propTypes.size,
  innerStyles: PropTypes.object
};
UIIconHolder.defaultProps = {
  padding: 0.5,
  rotate: 0,
  borderStyle: 'solid',
  borderWidth: 0
};
UIIconHolder.displayName = 'UIIconHolder';
export default UIIconHolder;